/* KlangWald Scroll-Reveal: robust gegen schnelles Scrollen und Anker-Sprünge */
window.kwWatch=function(els,cb){
  if(!('IntersectionObserver' in window)){els.forEach(cb);return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    if(e.isIntersecting||e.boundingClientRect.top<0){cb(e.target);io.unobserve(e.target)}
  })},{threshold:0.08});
  els.forEach(function(el){io.observe(el)});
};
